import flights from './flights'

export default {
  flights,
}
